export enum LiProfileEntryType {
	LINKEDIN_PROFILE_POSTS = "LINKEDIN_PROFILE_POSTS",
	LINKEDIN_PROFILE_COMMENTS = "LINKEDIN_PROFILE_COMMENTS",
	LINKEDIN_PROFILE_LIKES_TO_POST = "LINKEDIN_PROFILE_LIKES_TO_POST",
	LINKEDIN_PROFILE_LIKES_TO_COMMENT = "LINKEDIN_PROFILE_LIKES_TO_COMMENT",
	LINKEDIN_PROFILE_COMMENTS_TO_POST = "LINKEDIN_PROFILE_COMMENTS_TO_POST",
}

export enum LiProfileType {
	POST = "POST",
	COMMENT = "COMMENT",
	LIKE_TO_POST = "LIKE_TO_POST",
	LIKE_TO_COMMENT = "LIKE_TO_COMMENT",
	COMMENT_TO_POST = "COMMENT_TO_POST",
}

export enum LiProfileVisitsType {
	VISITORS = "VISITORS",
	CONNECTION_REQUESTS = "CONNECTION_REQUESTS",
}

export enum LiProfileVisitsTimeframe {
	DAYS14 = "DAYS14",
	DAYS28 = "DAYS28",
	DAYS90 = "DAYS90",
	DAYS365 = "DAYS365",
}

export enum LiPostType {
	BY_TOPIC = "BY_TOPIC",
	BY_URL = "BY_URL",
	BY_PROFILE = "BY_PROFILE",
}
